module.exports = __webpack_public_path__ + "static/media/img-get-tower-buying.fd7a97ae.png";